import React from "react"

import './BlueGrayBox.scss';

export const BlueGrayBox = ({className, ...props}) => {
    return (<div className={`bluebox lightgrayblue ${className}`} {...props}>{props.children}</div>)
}